<h1 class="text-title-4 mb-8">
  {{ 'rogers.notRegistered.' + type + '.header' | translate }}
</h1>
<p class="text-body-lg" [innerHTML]="
  'rogers.notRegistered.' + type + '.body'
      | translate: { email: autoRegEmail }
  ">
</p>
<p class="mb-32 text-body-lg">
  <span *ngIf="isAutoreg" [innerHTML]="'rogers.notRegistered.autoreg.li02' | translate"></span>
  <strong *ngIf="!isAutoreg">{{autoRegEmail}}</strong>
</p>
<button ds-button role="button" class="w-100" (click)="onBack()" *ngIf="!(isAutoreg || type==='account')">
  <span>{{ 'common.tryAgain' | translate }}</span>
</button>
<button ds-button role="button" class="w-100 mt-16 mb-96" [variant]="isAutoreg || type==='account'? 'primary':'secondary'"
  (click)="onRegister()"
  [attr.title]="'rogers.notRegistered.accessibility' | translate">
  <span *ngIf="!recoveryInProgress">{{ 'rogers.notRegistered.register' | translate }}</span>
  <eas-loader class="loader" *ngIf="recoveryInProgress"></eas-loader>
</button>
<ng-container ssTrackEvent [event]="track.notRegisteredPageView[type]"></ng-container>
